import instance from "./api";
import { AxiosResponse } from "axios";
import { ICurrencyRate, ISystemPercent } from "../helpers/types";

export default class CurrencyRatesService {
    static async findAll(): Promise<AxiosResponse<ICurrencyRate[]>> {
        return instance.get<ICurrencyRate[]>("currency-rates");
    }

    static async findOne(rateID: number): Promise<AxiosResponse<ICurrencyRate>> {
        return instance.get<ICurrencyRate>(`currency-rates/${rateID}`);
    }

    static async create(rate: FormData): Promise<AxiosResponse<ICurrencyRate>> {
        return instance.post<ICurrencyRate>("currency-rates", rate);
    }

    static async update(rate: FormData, rateID: number): Promise<AxiosResponse<ICurrencyRate>> {
        return instance.put<ICurrencyRate>(`currency-rates/${rateID}`, rate);
    }

    static async delete(rateID: number): Promise<AxiosResponse<{ id: number }>> {
        return instance.delete<{ id: number }>(`currency-rates/${rateID}`);
    }

    static async saveAll(formData: FormData): Promise<AxiosResponse<ICurrencyRate[]>> {
        return instance.put<ICurrencyRate[]>("currency-rates/bulk", formData);
    }

    static async findPercentByType(type: string): Promise<AxiosResponse<ISystemPercent>> {
        return instance.get<ISystemPercent>(`currency-rates/percents/type/${type}`);
    }

    static async updatePercentByType(type: string, percent: { value: string }): Promise<AxiosResponse<ISystemPercent>> {
        return instance.put<ISystemPercent>(`currency-rates/percents/type/${type}`, percent);
    }
}